import { config } from './config'

export type LogLevel = 'error' | 'warn' | 'info' | 'debug'

const getLogLevelPriority = (level: LogLevel): number => {
  switch (level) {
    case 'error':
      return 4 // Highest priority
    case 'warn':
      return 3
    case 'info':
      return 2
    case 'debug':
      return 1 // Lowest priority
    default:
      return 1
  }
}

const shouldLog = (level: LogLevel): boolean => {
  const currentLevelPriority = getLogLevelPriority(config.logLevel ?? 'debug')
  const messageLevelPriority = getLogLevelPriority(level)
  return messageLevelPriority >= currentLevelPriority
}

const formatMessage = (message: string | Error): string => {
  if (message instanceof Error) {
    return message.message || message.toString()
  }
  return message
}

export const logger = {
  error: (message: string | Error, ...args: any[]): void => {
    if (shouldLog('error')) {
      // eslint-disable-next-line no-console
      console.error(`[ERROR] ${formatMessage(message)}`, ...args)
    }
  },

  warn: (message: string | Error, ...args: any[]): void => {
    if (shouldLog('warn')) {
      // eslint-disable-next-line no-console
      console.warn(`[WARN] ${formatMessage(message)}`, ...args)
    }
  },

  info: (message: string | Error, ...args: any[]): void => {
    if (shouldLog('info')) {
      // eslint-disable-next-line no-console
      console.info(`[INFO] ${formatMessage(message)}`, ...args)
    }
  },

  debug: (message: string | Error, ...args: any[]): void => {
    if (shouldLog('debug')) {
      // eslint-disable-next-line no-console
      console.debug(`[DEBUG] ${formatMessage(message)}`, ...args)
    }
  },
}
